<template>
  <div class="navigation">
    <van-tabbar route>
      <van-tabbar-item replace to="/">
        <span>首页</span>
        <template v-slot:icon="props">
          <img :src="props.active ? navList[0].active : navList[0].inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace to="report" v-if="is_inspector == 1">
        <span></span>
        <template v-slot:icon="props">
          <img
            :src="props.active ? navList[1].active : navList[1].inactive"
            class="img-con"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace :to="{name: 'Mine'}">
        <span class="mine-title">我的</span>
        <template v-slot:icon="props">
          <img :src="props.active ? navList[2].active : navList[2].inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_inspector: this.$store.state.user.userInfo.is_inspector,
      navList: [
        {
          name: "首页",
          link: "/",
          active: require("../../assets/images/tabber/selectHome.png"),
          inactive: require("../../assets/images/tabber/home.png"),
        },
        {
          name: "",
          link: "/report",
          active: require("../../assets/images/tabber/report.png"),
          inactive: require("../../assets/images/tabber/report.png"),
        },
        {
          name: "个人中心",
          link: "/Mine",
          active: require("../../assets/images/tabber/selectMy.png"),
          inactive: require("../../assets/images/tabber/my.png"),
        },
      ],
    };
  }
};
</script>

<style scoped lang="less">
.navigation {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  /deep/ .van-tabbar {
    .img-con {
      width: 1rem;
      height: 1rem;
      position: relative;
      top: -0.4rem;
      z-index: 999;
    }
    // .mine-title{
    //   text-align: center;
    // }
    // .mine-icon {
    //   width: 20px;
    //   height: 20px;
    //   position: relative;
    //   top: -10px;
    //   z-index: 999;
    // }
  }
}
</style>